export const MATCH_TRACKER_AVAILABLE_SPORTS = [
  'Soccer',
  'Tennis',
  'Handball',
  'IceHockey',
  'Basketball',
  'Volleyball',
  'LeagueOfLegends',
  'Cricket',
  'AmericanFootball',
  'RugbyLeague',
  'Darts',
  'Dota2',
  'WaterPolo'
];

export const MS_STATISTICS_AVAILABLE_SPORTS = [
  'Soccer',
  'Tennis',
  'Basketball',
  'LeagueOfLegends',
  'Dota2'
];

export const TIMELINE_AVAILABLE_SPORTS = ['Soccer'];
